export const KEYS = {
  AUTH_KEY: "auth_key",
  OAUTH_REDIRECT_PATH_KEY: "oauth_redirect_path",
  OAUTH_TOKEN_PERISTENCE_KEY: "oauth_token_persist",
  OAUTH_TOKEN_KEY: "oauth_token",
  APP_ONBOARDING_VERSION_KEY: "app_onboarding_version",
};
